import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useSetPageContext } from "@/hooks/use-page-context";
import { useSession } from "@/hooks/use-session";
import { DonationTable } from "@/components/fundraising/DonationTable";
import { DonationDetailPanel } from "@/components/fundraising/DonationDetailPanel";
import { FundraisingPageHeader } from "@/components/fundraising/FundraisingPageHeader";
import type { DonationListItem } from "@/types/fundraising";

export const Route = createFileRoute("/_app/_/fundraising/donations")({
	component: FundraisingDonationsPage,
});

function FundraisingDonationsPage() {
	useSetPageContext({
		page_key: "fundraising.donations",
		page_title: "Donations",
		available_actions: ["create_task", "generate_content"],
		current_data_summary: null,
	});

	const session = useSession();
	const campaignId = session.campaign?.id;

	const [selectedDonation, setSelectedDonation] =
		useState<DonationListItem | null>(null);

	if (!campaignId) {
		return (
			<div className="p-6 text-muted-foreground">
				No campaign selected.
			</div>
		);
	}

	return (
		<div className="mx-auto max-w-7xl space-y-6 p-6">
			<FundraisingPageHeader
				title="Donations"
				subtitle="Review every contribution and its status."
				campaignId={campaignId}
			/>

			<DonationTable
				campaignId={campaignId}
				onSelect={setSelectedDonation}
			/>

			<DonationDetailPanel
				campaignId={campaignId}
				donationId={selectedDonation?.id}
				open={!!selectedDonation}
				onOpenChange={(open) => {
					if (!open) setSelectedDonation(null);
				}}
			/>
		</div>
	);
}
